/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const IconWrap = styled('span')`
	display: flex;
	width: ${(props) => props.width || '24px'};
	margin-right: ${(props) => props?.marginRight || '1rem'};
	fill: ${(props) => props.fill || 'white'};
`;

const BigIconWrap = styled('span')`
	display: flex;
	width: ${(props) => props.width || '38px'};
	margin-right: ${(props) => props?.marginRight || '1rem'};
	fill: ${(props) => props.fill || 'white'};
`;

export function NodataSVG() {
	return (
		<IconWrap>
			<svg
				fill="#c2c2c2"
				version="1.1"
				id="Layer_1"
				width="800px"
				height="800px"
				viewBox="0 0 512 512"
				xmlSpace="preserve"
				stroke="#c2c2c2"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					{' '}
					<g>
						{' '}
						<path d="M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472 c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z" />{' '}
						<g>
							{' '}
							<path d="M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256 h37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531 l54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z" />{' '}
						</g>{' '}
						<path d="M384,184c0-22.094-17.938-40-40-40s-40,17.906-40,40c0,22.062,17.938,40,40,40S384,206.062,384,184z M314,184 c0-16.547,13.469-30,30-30c6.438,0,12.469,2.094,17.375,5.562l-41.781,41.812C316.078,196.469,314,190.438,314,184z M326.625,208.406l41.781-41.766C371.938,171.547,374,177.562,374,184c0,16.531-13.469,30-30,30 C337.562,214,331.531,211.938,326.625,208.406z" />{' '}
					</g>{' '}
				</g>
			</svg>
		</IconWrap>
	);
}
export function GreenTickIconSVG() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_2386_3255)">
					<path
						d="M6.40005 12.0008L11.2 16.0008L17.6 8.00078M12 23.2008C10.5292 23.2008 9.07284 22.9111 7.71399 22.3482C6.35515 21.7854 5.12047 20.9604 4.08045 19.9204C3.04044 18.8804 2.21545 17.6457 1.6526 16.2868C1.08975 14.928 0.800049 13.4716 0.800049 12.0008C0.800049 10.53 1.08975 9.07357 1.6526 7.71473C2.21545 6.35588 3.04044 5.1212 4.08045 4.08119C5.12047 3.04117 6.35515 2.21618 7.71399 1.65333C9.07284 1.09048 10.5292 0.800781 12 0.800781C14.9705 0.800781 17.8192 1.98078 19.9196 4.08119C22.0201 6.18159 23.2 9.03036 23.2 12.0008C23.2 14.9712 22.0201 17.82 19.9196 19.9204C17.8192 22.0208 14.9705 23.2008 12 23.2008Z"
						stroke="#1C8F39"
					/>
				</g>
				<defs>
					<clipPath id="clip0_2386_3255">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function RedTickIconSVG() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12C21.998 13.3827 21.7353 14.6827 21.212 15.9C20.6887 17.1173 19.9763 18.1757 19.075 19.075C18.1737 19.9743 17.1153 20.687 15.9 21.213C14.6847 21.739 13.3847 22.0013 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
					fill="#EC221F"
				/>
			</svg>
		</IconWrap>
	);
}

export function BluefileIconSVG() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H14C14.2652 2.00006 14.5195 2.10545 14.707 2.293L19.707 7.293C19.8946 7.48049 19.9999 7.73481 20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4ZM17.586 8L14 4.414V8H17.586ZM12 4H6V20H18V10H13C12.7348 10 12.4804 9.89464 12.2929 9.70711C12.1054 9.51957 12 9.26522 12 9V4ZM8 13C8 12.7348 8.10536 12.4804 8.29289 12.2929C8.48043 12.1054 8.73478 12 9 12H15C15.2652 12 15.5196 12.1054 15.7071 12.2929C15.8946 12.4804 16 12.7348 16 13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H9C8.73478 14 8.48043 13.8946 8.29289 13.7071C8.10536 13.5196 8 13.2652 8 13ZM8 17C8 16.7348 8.10536 16.4804 8.29289 16.2929C8.48043 16.1054 8.73478 16 9 16H15C15.2652 16 15.5196 16.1054 15.7071 16.2929C15.8946 16.4804 16 16.7348 16 17C16 17.2652 15.8946 17.5196 15.7071 17.7071C15.5196 17.8946 15.2652 18 15 18H9C8.73478 18 8.48043 17.8946 8.29289 17.7071C8.10536 17.5196 8 17.2652 8 17Z"
					fill="#007AFF"
				/>
			</svg>
		</IconWrap>
	);
}

export function BlackfileIconSVG() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<rect width="24" height="24" fill="white" />
				<path
					d="M4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H14C14.2652 2.00006 14.5195 2.10545 14.707 2.293L19.707 7.293C19.8946 7.48049 19.9999 7.73481 20 8V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4ZM17.586 8L14 4.414V8H17.586ZM12 4H6V20H18V10H13C12.7348 10 12.4804 9.89464 12.2929 9.70711C12.1054 9.51957 12 9.26522 12 9V4ZM8 13C8 12.7348 8.10536 12.4804 8.29289 12.2929C8.48043 12.1054 8.73478 12 9 12H15C15.2652 12 15.5196 12.1054 15.7071 12.2929C15.8946 12.4804 16 12.7348 16 13C16 13.2652 15.8946 13.5196 15.7071 13.7071C15.5196 13.8946 15.2652 14 15 14H9C8.73478 14 8.48043 13.8946 8.29289 13.7071C8.10536 13.5196 8 13.2652 8 13ZM8 17C8 16.7348 8.10536 16.4804 8.29289 16.2929C8.48043 16.1054 8.73478 16 9 16H15C15.2652 16 15.5196 16.1054 15.7071 16.2929C15.8946 16.4804 16 16.7348 16 17C16 17.2652 15.8946 17.5196 15.7071 17.7071C15.5196 17.8946 15.2652 18 15 18H9C8.73478 18 8.48043 17.8946 8.29289 17.7071C8.10536 17.5196 8 17.2652 8 17Z"
					fill="#6D6C6C"
				/>
				<rect width="9" height="9" transform="translate(12 2)" fill="white" />
				<path
					d="M20.4286 6.57143H17.5714V9.42857C17.5714 9.58012 17.5112 9.72547 17.4041 9.83263C17.2969 9.9398 17.1516 10 17 10C16.8484 10 16.7031 9.9398 16.5959 9.83263C16.4888 9.72547 16.4286 9.58012 16.4286 9.42857V6.57143H13.5714C13.4199 6.57143 13.2745 6.51122 13.1674 6.40406C13.0602 6.2969 13 6.15155 13 6C13 5.84845 13.0602 5.7031 13.1674 5.59594C13.2745 5.48878 13.4199 5.42857 13.5714 5.42857H16.4286V2.57143C16.4286 2.41988 16.4888 2.27453 16.5959 2.16737C16.7031 2.0602 16.8484 2 17 2C17.1516 2 17.2969 2.0602 17.4041 2.16737C17.5112 2.27453 17.5714 2.41988 17.5714 2.57143V5.42857H20.4286C20.5801 5.42857 20.7255 5.48878 20.8326 5.59594C20.9398 5.7031 21 5.84845 21 6C21 6.15155 20.9398 6.2969 20.8326 6.40406C20.7255 6.51122 20.5801 6.57143 20.4286 6.57143Z"
					fill="#6D6C6C"
				/>
			</svg>
		</IconWrap>
	);
}

export function HistoryIconSVG() {
	return (
		<IconWrap>
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z"
					fill="black"
				/>
				<path
					d="M7.25 5.25C7.25 5.44891 7.32902 5.63968 7.46967 5.78033C7.61032 5.92098 7.80109 6 8 6C8.19891 6 8.38968 5.92098 8.53033 5.78033C8.67098 5.63968 8.75 5.44891 8.75 5.25C8.75 5.05109 8.67098 4.86032 8.53033 4.71967C8.38968 4.57902 8.19891 4.5 8 4.5C7.80109 4.5 7.61032 4.57902 7.46967 4.71967C7.32902 4.86032 7.25 5.05109 7.25 5.25ZM8.375 7H7.625C7.55625 7 7.5 7.05625 7.5 7.125V11.375C7.5 11.4437 7.55625 11.5 7.625 11.5H8.375C8.44375 11.5 8.5 11.4437 8.5 11.375V7.125C8.5 7.05625 8.44375 7 8.375 7Z"
					fill="black"
				/>
			</svg>
		</IconWrap>
	);
}
export function AdhocRequestIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M21 14C21 15.4 21 16.1 20.727 16.635C20.4874 17.1051 20.1051 17.4874 19.635 17.727C19.1 18 18.4 18 17 18H7C5.6 18 4.9 18 4.365 17.727C3.89451 17.4875 3.5119 17.1053 3.272 16.635C3 16.1 3 15.4 3 14M6 14H18M6 10H18M6 6H18"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconWrap>
	);
}
export function EyeIconSVG() {
	return (
		<IconWrap>
			<svg
				version="1.0"
				id="Layer_1"
				width="40px"
				height="40px"
				viewBox="0 0 64 64"
				enableBackground="new 0 0 64 64"
				xmlSpace="preserve"
				fill="#000000"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					{' '}
					<path
						fill="#231F20"
						d="M63.714,30.516C63.347,29.594,54.448,8,31.999,8S0.651,29.594,0.284,30.516 c-0.379,0.953-0.379,2.016,0,2.969C0.651,34.406,9.55,56,31.999,56s31.348-21.594,31.715-22.516 C64.093,32.531,64.093,31.469,63.714,30.516z M31.999,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S36.417,40,31.999,40z"
					/>{' '}
				</g>
			</svg>
		</IconWrap>
	);
}
export function DownloadIconSVG() {
	return (
		<IconWrap>
			<svg
				version="1.0"
				id="Download"
				width="22"
				height="22"
				viewBox="0 0 22 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
					fill="white"
					stroke="white"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7 11L11 15L15 11"
					stroke="#0C1741"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11 7V15"
					stroke="#0C1741"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconWrap>
	);
}
export function WarningIconApps() {
	return (
		<IconWrap>
			<svg
				width="16px"
				height="16px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				stroke="#e66119"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					{' '}
					<circle cx="12" cy="17" r="1" fill="#e66119" />{' '}
					<path
						d="M12 10L12 14"
						stroke="#e66119"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
					<path
						d="M3.44722 18.1056L10.2111 4.57771C10.9482 3.10361 13.0518 3.10362 13.7889 4.57771L20.5528 18.1056C21.2177 19.4354 20.2507 21 18.7639 21H5.23607C3.7493 21 2.78231 19.4354 3.44722 18.1056Z"
						stroke="#e66119"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
				</g>
			</svg>
		</IconWrap>
	);
}

export function MessageIConsAPp() {
	return (
		<IconWrap>
			<svg
				width="16px"
				height="16px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M3 7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2Z"
					stroke="#000000"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconWrap>
	);
}

export function RejectIConsAPp() {
	return (
		<IconWrap>
			<svg
				fill="#d21414"
				width="34px"
				height="34px"
				viewBox="0 0 200 200"
				data-name="Layer 1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					<title />

					<path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Z" />

					<path d="M128.5,74a9.67,9.67,0,0,0-14,0L100,88.5l-14-14a9.9,9.9,0,0,0-14,14l14,14-14,14a9.9,9.9,0,0,0,14,14l14-14,14,14a9.9,9.9,0,0,0,14-14l-14-14,14-14A10.77,10.77,0,0,0,128.5,74Z" />
				</g>
			</svg>
		</IconWrap>
	);
}
export function APprovedICons() {
	return (
		<IconWrap>
			<svg
				fill="#068e0f"
				width="34px"
				height="34px"
				viewBox="0 0 200 200"
				data-name="Layer 1"
				id="Layer_1"
				xmlns="http://www.w3.org/2000/svg"
				stroke="#068e0f"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					<title />

					<path d="M100,15a85,85,0,1,0,85,85A84.93,84.93,0,0,0,100,15Zm0,150a65,65,0,1,1,65-65A64.87,64.87,0,0,1,100,165Zm25-91.5-29,35L76,94c-4.5-3.5-10.5-2.5-14,2s-2.5,10.5,2,14c6,4.5,12.5,9,18.5,13.5,4.5,3,8.5,7.5,14,8,1.5,0,3.5,0,5-1l3-3,22.5-27c4-5,8-9.5,12-14.5,3-4,4-9,.5-13L138,71.5c-3.5-2.5-9.5-2-13,2Z" />
				</g>
			</svg>
		</IconWrap>
	);
}

export function AdhocAppprvalIcons() {
	return (
		<BigIconWrap>
			<svg
				width="60"
				height="60"
				viewBox="0 0 28 28"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="14" cy="14" r="14" fill="#FFCC00" />
				<path
					d="M16.0996 9.80078H9.09961V15.8674H16.0996V9.80078Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M16.0996 12.1338H17.9663L19.3663 13.5338V15.8671H16.0996V12.1338Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.1999 18.2005C11.8442 18.2005 12.3665 17.6782 12.3665 17.0339C12.3665 16.3895 11.8442 15.8672 11.1999 15.8672C10.5555 15.8672 10.0332 16.3895 10.0332 17.0339C10.0332 17.6782 10.5555 18.2005 11.1999 18.2005Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M17.2663 18.2005C17.9106 18.2005 18.4329 17.6782 18.4329 17.0339C18.4329 16.3895 17.9106 15.8672 17.2663 15.8672C16.6219 15.8672 16.0996 16.3895 16.0996 17.0339C16.0996 17.6782 16.6219 18.2005 17.2663 18.2005Z"
					stroke="black"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</BigIconWrap>
	);
}

export function DashboardIcons() {
	return (
		<IconWrap>
			<svg viewBox="0 0 24 24">
				<path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
			</svg>
		</IconWrap>
	);
}

export function WarningIcons({ fillColorCode = 'none', strokeColorCode = '6E57F9' }) {
	const FillColor = fillColorCode === 'none' ? fillColorCode : `#${fillColorCode}`;
	const StrokeColor = `#${strokeColorCode}`;
	return (
		<IconWrap>
			<svg viewBox="0 0 16 14" fill={FillColor}>
				<path
					d="M6.85496 1.64509L1.17959 11.1197C1.06257 11.3223 1.00066 11.5521 1.00001 11.7861C0.99935 12.0201 1.05998 12.2501 1.17585 12.4534C1.29173 12.6567 1.45882 12.8261 1.66049 12.9448C1.86217 13.0635 2.0914 13.1273 2.32538 13.1298H13.6761C13.9101 13.1273 14.1393 13.0635 14.341 12.9448C14.5427 12.8261 14.7098 12.6567 14.8257 12.4534C14.9415 12.2501 15.0022 12.0201 15.0015 11.7861C15.0008 11.5521 14.9389 11.3223 14.8219 11.1197L9.14655 1.64509C9.0271 1.44817 8.85891 1.28535 8.65821 1.17236C8.45751 1.05936 8.23108 1 8.00075 1C7.77043 1 7.544 1.05936 7.3433 1.17236C7.1426 1.28535 6.97441 1.44817 6.85496 1.64509Z"
					stroke={StrokeColor}
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 5.08984V7.77007"
					stroke={StrokeColor}
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8 10.4492H8.00768"
					stroke={StrokeColor}
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconWrap>
	);
}
WarningIcons.propTypes = {
	fillColorCode: PropTypes.string,
	strokeColorCode: PropTypes.string,
};

export function TripsIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_78_123)">
					<path
						d="M18.92 9.01C18.72 8.42 18.16 8 17.5 8H6.5C5.84 8 5.29 8.42 5.08 9.01L3 15V23C3 23.55 3.45 24 4 24H5C5.55 24 6 23.55 6 23V22H18V23C18 23.55 18.45 24 19 24H20C20.55 24 21 23.55 21 23V15L18.92 9.01ZM6.85 10H17.14L18.18 13H5.81L6.85 10ZM6 17.5C6 16.67 6.67 16 7.5 16C8.33 16 9 16.67 9 17.5C9 18.33 8.33 19 7.5 19C6.67 19 6 18.33 6 17.5ZM15 17.5C15 16.67 15.67 16 16.5 16C17.33 16 18 16.67 18 17.5C18 18.33 17.33 19 16.5 19C15.67 19 15 18.33 15 17.5ZM12 6.36L9.17 3.54L10.58 2.13L12 3.54L15.54 0L16.95 1.41L12 6.36Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_78_123">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}
export function TripIntercityIcon() {
	return <IconWrap></IconWrap>;
}

export function IntracityTripIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<circle cx="12" cy="12" r="11.3" stroke="white" strokeWidth="1.4" />
				<rect
					x="6.87139"
					y="10.4207"
					width="6.70932"
					height="6.70932"
					stroke="white"
					strokeWidth="1.4"
				/>
				<rect
					x="10.4192"
					y="6.87187"
					width="6.70932"
					height="6.70932"
					stroke="white"
					strokeWidth="1.4"
				/>
				<rect x="10.2261" y="10.2266" width="3.54783" height="3.54783" fill="white" />
			</svg>
		</IconWrap>
	);
}

export function IntercityTripIcon() {
	return (
		<IconWrap>
			<img
				src="/images/intercity.png"
				alt="Intercity Trip"
				style={{ width: '100%', height: '100%', objectFit: 'contain' }}
			/>
		</IconWrap>
	);
}

export function TripHistoryIcon() {
	return (
		<IconWrap>
			<img
				src="/images/triphistory.png"
				alt="Trip History"
				style={{ width: '100%', height: '100%', objectFit: 'contain' }}
			/>
		</IconWrap>
	);
}

export function VehiclesIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="25"
				viewBox="0 0 24 25"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_40_788)">
					<path
						d="M20 8.85156H17V4.85156H3C1.9 4.85156 1 5.75156 1 6.85156V17.8516H3C3 19.5116 4.34 20.8516 6 20.8516C7.66 20.8516 9 19.5116 9 17.8516H15C15 19.5116 16.34 20.8516 18 20.8516C19.66 20.8516 21 19.5116 21 17.8516H23V12.8516L20 8.85156ZM6 19.3516C5.17 19.3516 4.5 18.6816 4.5 17.8516C4.5 17.0216 5.17 16.3516 6 16.3516C6.83 16.3516 7.5 17.0216 7.5 17.8516C7.5 18.6816 6.83 19.3516 6 19.3516ZM19.5 10.3516L21.46 12.8516H17V10.3516H19.5ZM18 19.3516C17.17 19.3516 16.5 18.6816 16.5 17.8516C16.5 17.0216 17.17 16.3516 18 16.3516C18.83 16.3516 19.5 17.0216 19.5 17.8516C19.5 18.6816 18.83 19.3516 18 19.3516Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_40_788">
						<rect
							width="24"
							height="24"
							fill="white"
							transform="translate(0 0.851562)"
						/>
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function ClientsIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_78_128)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M9 17L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12L9 17ZM11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12Z"
						fill="white"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M15.47 20.5L12 17L13.4 15.59L15.47 17.67L20.6 12.5L22 13.91L15.47 20.5Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_78_128">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function DriversIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_78_160)">
					<path
						d="M17.91 13C17.97 13.16 18 13.33 18 13.5C18 14.33 17.33 15 16.5 15C15.67 15 15 14.33 15 13.5C15 13.11 15.15 12.76 15.39 12.49C13.76 11.83 12.43 10.58 11.68 9H5.81L6.85 6H11C11 5.31 11.1 4.63 11.29 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V12.32C19.95 12.83 18.84 13.01 17.91 13ZM7.5 15C6.67 15 6 14.33 6 13.5C6 12.67 6.67 12 7.5 12C8.33 12 9 12.67 9 13.5C9 14.33 8.33 15 7.5 15Z"
						fill="white"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M18 1C15.24 1 13 3.24 13 6C13 8.76 15.24 11 18 11C20.76 11 23 8.76 23 6C23 3.24 20.76 1 18 1ZM18 3.33594C18.7257 3.33594 19.3115 3.93047 19.3115 4.66699C19.3115 5.40351 18.7257 5.99804 18 5.99804C17.2743 5.99804 16.6885 5.40351 16.6885 4.66699C16.6885 3.93047 17.2743 3.33594 18 3.33594ZM20.623 7.99463V8.66016H15.377V7.99463C15.377 7.10726 17.1256 6.66357 18 6.66357C18.8743 6.66357 20.623 7.10726 20.623 7.99463Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_78_160">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function NodeManagementIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_node_management)">
					<path
						d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_node_management">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function RouteManagementIcon({ height, width, ...restProps }) {
	return (
		<IconWrap {...restProps} style={{ height: height || width || '24px' }}>
			<svg
				width="100%"
				height="100%"
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16 14C17.1045 14 18 14.8954 18 16C18 17.1045 17.1045 18 16 18C14.8954 18 14 17.1045 14 16C14 14.8954 14.8954 14 16 14ZM4.8293 0.999984H10.5C12.9853 0.999984 15 3.01472 15 5.49998C15 7.9853 12.9853 9.99998 10.5 9.99998H6.50002C5.11927 9.99998 3.99998 11.1193 3.99998 12.5C3.99998 13.8807 5.11927 15 6.50002 15H13.1707C13.0574 15.3212 12.9996 15.6594 13 16C13 16.3506 13.0602 16.6872 13.1707 17H6.50002C4.0147 17 2.00002 14.9853 2.00002 12.5C2.00002 10.0147 4.0147 8.00002 6.50002 8.00002H10.5C11.8807 8.00002 13 6.88073 13 5.49998C13 4.11928 11.8807 3 10.5 3H4.8293C4.94265 2.6788 5.00038 2.34063 5.00002 2.00002C5.00039 1.65939 4.94265 1.3212 4.8293 0.999984ZM2.00002 0C3.10458 0 3.99998 0.895453 3.99998 2.00002C3.99998 3.10458 3.10458 3.99998 2.00002 3.99998C0.895453 3.99998 0 3.10458 0 2.00002C0 0.895453 0.895453 0 2.00002 0Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}
RouteManagementIcon.propTypes = {
	height: PropTypes.string,
	width: PropTypes.string,
};

export function EmployeesIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_78_138)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M15.1512 4.22877H20.4031C21.5586 4.22877 22.5039 5.27018 22.5039 6.54302V19.2714C22.5039 20.5442 21.5586 21.5856 20.4031 21.5856H3.59687C2.44145 21.5856 1.49609 20.5442 1.49609 19.2714V6.54302C1.49609 5.27018 2.44145 4.22877 3.59687 4.22877H8.84883L10.2028 4.2285C11.0796 4.23056 11.2479 4.22919 11.4656 4.22743C11.6633 4.22583 11.9017 4.2239 12.7482 4.2239L13.3394 4.22266L13.9832 4.22516C14.7014 4.22493 14.8231 4.22744 14.8912 4.22885C14.9397 4.22985 14.961 4.23029 15.1512 4.22877ZM10.9496 6.54302H13.0504V5.95766H10.9496V6.54302ZM7.9252 8.65728C9.12992 8.65728 10.1024 9.72857 10.1024 11.0557C10.1024 12.3828 9.12992 13.4541 7.9252 13.4541C6.72049 13.4541 5.748 12.3828 5.748 11.0557C5.748 9.72857 6.72049 8.65728 7.9252 8.65728ZM12.2796 17.0518V18.251H3.5708V17.0518C3.5708 15.4528 6.47374 14.6534 7.9252 14.6534C9.37667 14.6534 12.2796 15.4528 12.2796 17.0518ZM14.9631 11.9822H20.2805V11.2101H14.9631V11.9822ZM14.9631 13.5265H20.2805V12.7544H14.9631V13.5265ZM18.8415 14.4223H14.986V13.9991H18.8415V14.4223ZM18.8415 15.2687H14.986V14.8455H18.8415V15.2687Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_78_138">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function UserManagementIcons() {
	return (
		<IconWrap>
			<svg viewBox="0 0 24 24">
				<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
			</svg>
		</IconWrap>
	);
}

export function LogoutIcons() {
	return (
		<IconWrap fill="#091744" marginRight="0.5rem">
			<svg viewBox="0 0 24 24">
				<path d="M13 3h-2v10h2V3zm4.83 2.17-1.42 1.42A6.92 6.92 0 0 1 19 12c0 3.87-3.13 7-7 7A6.995 6.995 0 0 1 7.58 6.58L6.17 5.17A8.932 8.932 0 0 0 3 12a9 9 0 0 0 18 0c0-2.74-1.23-5.18-3.17-6.83z" />
			</svg>
		</IconWrap>
	);
}

export function ClientIcons() {
	return (
		<IconWrap>
			<svg viewBox="0 0 24 24">
				<path d="M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" />
			</svg>
		</IconWrap>
	);
}
export function AirIcons() {
	return (
		<IconWrap>
			<svg
				fill="#fff"
				version="1.1"
				id="Capa_1"
				xmlns="http://www.w3.org/2000/svg"
				width="800px"
				height="800px"
				viewBox="0 0 254.759 254.759"
			>
				<g>
					<g>
						<path
							d="M239.564,0.278c-7.636-1.783-22.799,5.204-33.86,15.618L149.717,68.59c-2.207,2.088-6.305,2.882-9.138,1.783
			L38.461,30.807c-2.835-1.094-7.08-0.483-9.479,1.386L8.844,47.805c-2.399,1.864-2.226,4.627,0.392,6.174l94.086,55.592
			c2.614,1.542,2.48,3.785-0.177,5.262c-10.216,5.666-29.951,24.101-53.434,57.093c-1.764,2.474-4.987,4.563-8.002,4.182
			l-23.513-3.024c-3.015-0.383-7.054,1.176-9.019,3.49l-7.875,9.27c-1.967,2.314-1.347,5.269,1.386,6.6l20.995,10.192
			c2.735,1.325,3.853,4.616,2.9,7.505c-1.008,3.057-2.011,7.168-2.035,11.495c-0.019,3.038,2.963,6.081,5.998,6.221
			c4.219,0.196,10.3-0.354,16.092-3.878c2.595-1.587,5.4-1.106,6.69,1.643l12.396,26.514c1.291,2.754,4.264,3.453,6.648,1.563
			l5.491-4.345c2.385-1.886,4.125-5.871,3.89-8.905l-2.098-27.274c-0.233-3.024,1.706-6.721,4.292-8.321
			c11.892-7.351,43.17-27.857,57.132-48.36c1.713-2.516,4.191-2.604,5.806-0.032l54.75,87.171c1.615,2.576,4.644,2.89,6.758,0.71
			l11.164-11.519c2.118-2.184,3.057-6.281,2.096-9.166l-35.938-107.833c-0.961-2.877-0.079-7.036,1.975-9.273l49.467-53.93
			c10.268-11.199,18.066-26.722,17.412-34.684C253.919,9.969,247.199,2.065,239.564,0.278z"
						/>
					</g>
				</g>
			</svg>
		</IconWrap>
	);
}
export function ApprovalsSVG() {
	return (
		<IconWrap>
			<svg
				width="800px"
				height="800px"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					{' '}
					<g id="style=stroke">
						{' '}
						<g id="check-circle">
							{' '}
							<path
								id="vector (Stroke)"
								fillRule="evenodd"
								clipRule="evenodd"
								d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
								fill="#ffffff"
							/>{' '}
							<path
								id="vector (Stroke)_2"
								fillRule="evenodd"
								clipRule="evenodd"
								d="M16.5303 8.96967C16.8232 9.26256 16.8232 9.73744 16.5303 10.0303L11.9041 14.6566C11.2207 15.34 10.1126 15.34 9.42923 14.6566L7.46967 12.697C7.17678 12.4041 7.17678 11.9292 7.46967 11.6363C7.76256 11.3434 8.23744 11.3434 8.53033 11.6363L10.4899 13.5959C10.5875 13.6935 10.7458 13.6935 10.8434 13.5959L15.4697 8.96967C15.7626 8.67678 16.2374 8.67678 16.5303 8.96967Z"
								fill="#ffffff"
							/>{' '}
						</g>{' '}
					</g>{' '}
				</g>
			</svg>
		</IconWrap>
	);
}

export function ConsignmentNote() {
	return (
		<IconWrap>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="64px"
				height="64px"
				viewBox="0 0 24 24"
				fill="none"
			>
				<g id="SVGRepo_bgCarrier" strokeWidth="0" />

				<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

				<g id="SVGRepo_iconCarrier">
					{' '}
					<path
						d="M16 3.98999H8C6.93913 3.98999 5.92178 4.41135 5.17163 5.1615C4.42149 5.91164 4 6.92912 4 7.98999V17.99C4 19.0509 4.42149 20.0682 5.17163 20.8184C5.92178 21.5685 6.93913 21.99 8 21.99H16C17.0609 21.99 18.0783 21.5685 18.8284 20.8184C19.5786 20.0682 20 19.0509 20 17.99V7.98999C20 6.92912 19.5786 5.91164 18.8284 5.1615C18.0783 4.41135 17.0609 3.98999 16 3.98999Z"
						stroke="#f7f7f7"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
					<path
						d="M9 2V7"
						stroke="#f7f7f7"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
					<path
						d="M15 2V7"
						stroke="#f7f7f7"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
					<path
						d="M8 16H14"
						stroke="#f7f7f7"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
					<path
						d="M8 12H16"
						stroke="#f7f7f7"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>{' '}
				</g>
			</svg>
		</IconWrap>
	);
}

export function WarehousingIcon() {
	return (
		<IconWrap>
			<svg
				width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M3 21V9.5L12 3L21 9.5V21"
					stroke="white"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3 21H21"
					stroke="white"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7 21V13H17V21"
					stroke="white"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M7 17H17"
					stroke="white"
					strokeWidth="1.7"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</IconWrap>
	);
}

export function TemperatureDashboard() {
	return (
		<IconWrap>
			<svg
				width="20"
				height="20"
				viewBox="0 0 12 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6 0C7.02624 -8.02754e-07 8.01323 0.394435 8.75681 1.10172C9.5004 1.80901 9.94369 2.77504 9.995 3.8L10 4L10.001 10.728L10.056 10.786C10.8559 11.6594 11.3525 12.7677 11.472 13.946L11.493 14.222L11.5 14.5C11.4999 15.3828 11.2873 16.2526 10.8802 17.0359C10.4731 17.8192 9.8834 18.493 9.16096 19.0004C8.43853 19.5077 7.60459 19.8337 6.7296 19.9508C5.85461 20.0679 4.96429 19.9727 4.13386 19.6732C3.30344 19.3737 2.55732 18.8786 1.95854 18.2299C1.35977 17.5813 0.925941 16.798 0.693714 15.9463C0.461486 15.0946 0.437685 14.1995 0.624321 13.3367C0.810957 12.4738 1.20255 11.6686 1.766 10.989L1.945 10.784L1.999 10.727L2 4C1.99991 3.00884 2.36781 2.05296 3.03239 1.31761C3.69697 0.582274 4.61089 0.119859 5.597 0.02L5.8 0.00500011L6 0ZM6 2C5.49542 1.99984 5.00943 2.19041 4.63945 2.5335C4.26947 2.87659 4.04284 3.34684 4.005 3.85L4 4V11.593L3.667 11.891C3.14536 12.3575 2.77555 12.9697 2.60531 13.6485C2.43508 14.3273 2.47225 15.0416 2.71202 15.699C2.95178 16.3565 3.38314 16.927 3.95039 17.3368C4.51763 17.7467 5.19472 17.9771 5.89422 17.9983C6.59372 18.0195 7.28351 17.8305 7.87452 17.4557C8.46554 17.0809 8.93063 16.5376 9.20975 15.8958C9.48887 15.2541 9.5692 14.5434 9.44037 13.8555C9.31153 13.1677 8.97945 12.5342 8.487 12.037L8.334 11.892L8.001 11.594L8 4C8 3.46957 7.78929 2.96086 7.41421 2.58579C7.03914 2.21071 6.53043 2 6 2ZM6 6C6.26522 6 6.51957 6.10536 6.70711 6.29289C6.89464 6.48043 7 6.73478 7 7V12.208C7.5264 12.4377 7.95764 12.8417 8.22122 13.352C8.48479 13.8623 8.56461 14.4478 8.44727 15.0101C8.32992 15.5723 8.02256 16.077 7.57687 16.4393C7.13119 16.8015 6.57435 16.9993 6 16.9993C5.42565 16.9993 4.86881 16.8015 4.42313 16.4393C3.97744 16.077 3.67008 15.5723 3.55273 15.0101C3.43539 14.4478 3.51521 13.8623 3.77878 13.352C4.04236 12.8417 4.4736 12.4377 5 12.208V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}

export function ControlTower() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_5002_6428)">
					<path
						d="M7.30078 14.7L8.50078 13.5C7.50078 12.5 7.00078 11.2 7.00078 9.99999C7.00078 8.69999 7.50078 7.39999 8.50078 6.49999L7.30078 5.29999C6.00078 6.59999 5.30078 8.29999 5.30078 9.99999C5.30078 11.7 6.00078 13.4 7.30078 14.7Z"
						fill="white"
					/>
					<path
						d="M19.1004 2.89999L17.9004 4.09999C19.5004 5.69999 20.3004 7.89999 20.3004 9.99999C20.3004 12.1 19.5004 14.3 17.9004 15.9L19.1004 17.1C21.1004 15.1 22.0004 12.6 22.0004 9.99999C22.0004 7.39999 21.0004 4.89999 19.1004 2.89999Z"
						fill="white"
					/>
					<path
						d="M6.1 4.09999L4.9 2.89999C3 4.89999 2 7.39999 2 9.99999C2 12.6 3 15.1 4.9 17.1L6.1 15.9C4.5 14.3 3.7 12.1 3.7 9.99999C3.7 7.89999 4.5 5.69999 6.1 4.09999Z"
						fill="white"
					/>
					<path
						d="M16.7 14.7C18 13.4 18.7 11.7 18.7 9.99999C18.6 8.29999 18 6.59999 16.7 5.29999L15.5 6.49999C16.5 7.49999 17 8.79999 17 9.99999C17 11.3 16.5 12.6 15.5 13.5L16.7 14.7Z"
						fill="white"
					/>
					<path
						d="M14.5 10C14.5 8.62 13.38 7.5 12 7.5C10.62 7.5 9.5 8.62 9.5 10C9.5 10.76 9.84 11.42 10.37 11.88L7 22H9L9.67 20H14.34L15 22H17L13.63 11.88C14.16 11.42 14.5 10.76 14.5 10ZM10.33 18L12 13L13.67 18H10.33Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_5002_6428">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function WhatsApp() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g>
					<path
						d="M19.05 4.91C17.18 3.03 14.69 2 12.04 2C6.58005 2 2.13005 6.45 2.13005 11.91C2.13005 13.66 2.59005 15.36 3.45005 16.86L2.05005 22L7.30005 20.62C8.75005 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.9501 17.38 21.9501 11.92C21.9501 9.27 20.92 6.78 19.05 4.91ZM12.04 20.15C10.56 20.15 9.11005 19.75 7.84005 19L7.54005 18.82L4.42005 19.64L5.25005 16.6L5.05005 16.29C4.23005 14.98 3.79005 13.46 3.79005 11.91C3.79005 7.37 7.49005 3.67 12.03 3.67C14.23 3.67 16.3 4.53 17.85 6.09C19.41 7.65 20.26 9.72 20.26 11.92C20.2801 16.46 16.58 20.15 12.04 20.15ZM16.56 13.99C16.31 13.87 15.09 13.27 14.87 13.18C14.64 13.1 14.48 13.06 14.31 13.3C14.14 13.55 13.67 14.11 13.53 14.27C13.39 14.44 13.24 14.46 12.99 14.33C12.74 14.21 11.94 13.94 11 13.1C10.26 12.44 9.77005 11.63 9.62005 11.38C9.48005 11.13 9.60005 11 9.73005 10.87C9.84005 10.76 9.98005 10.58 10.1 10.44C10.22 10.3 10.27 10.19 10.35 10.03C10.43 9.86 10.39 9.72 10.33 9.6C10.27 9.48 9.77005 8.26 9.57005 7.76C9.37005 7.28 9.16005 7.34 9.01005 7.33C8.86005 7.33 8.70005 7.33 8.53005 7.33C8.36005 7.33 8.10005 7.39 7.87005 7.64C7.65005 7.89 7.01005 8.49 7.01005 9.71C7.01005 10.93 7.90005 12.11 8.02005 12.27C8.14005 12.44 9.77005 14.94 12.25 16.01C12.84 16.27 13.3 16.42 13.66 16.53C14.25 16.72 14.79 16.69 15.22 16.63C15.7 16.56 16.69 16.03 16.89 15.45C17.1 14.87 17.1 14.38 17.03 14.27C16.96 14.16 16.81 14.11 16.56 13.99Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath>
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</IconWrap>
	);
}

export function BusinessUnitIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 18 18"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1 18C0.716667 18 0.479333 17.904 0.288 17.712C0.0960001 17.5207 0 17.2833 0 17V14C0 13.7167 0.0960001 13.4793 0.288 13.288C0.479333 13.096 0.716667 13 1 13H4L8 9V5.8C7.4 5.58333 6.91667 5.22067 6.55 4.712C6.18333 4.204 6 3.63333 6 3C6 2.16667 6.29167 1.45833 6.875 0.875C7.45833 0.291667 8.16667 0 9 0C9.83333 0 10.5417 0.291667 11.125 0.875C11.7083 1.45833 12 2.16667 12 3C12 3.63333 11.8167 4.204 11.45 4.712C11.0833 5.22067 10.6 5.58333 10 5.8V9L14 13H17C17.2833 13 17.5207 13.096 17.712 13.288C17.904 13.4793 18 13.7167 18 14V17C18 17.2833 17.904 17.5207 17.712 17.712C17.5207 17.904 17.2833 18 17 18H14C13.7167 18 13.4793 17.904 13.288 17.712C13.096 17.5207 13 17.2833 13 17V14.95L9 10.95L5 14.95V17C5 17.2833 4.90433 17.5207 4.713 17.712C4.521 17.904 4.28333 18 4 18H1Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}

export function FinanceIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8 3H18L17 5H13.74C14.22 5.58 14.58 6.26 14.79 7H18L17 9H15C14.8757 10.2466 14.3341 11.4147 13.4628 12.315C12.5916 13.2153 11.4419 13.7949 10.2 13.96V14H9.5L15.5 21H13L7 14V12H9.5C11.26 12 12.72 10.7 12.96 9H7L8 7H12.66C12.1 5.82 10.9 5 9.5 5H7L8 3Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}

export function PaymentsIcon() {
	return (
		<IconWrap>
			<svg
				width="19"
				height="19"
				viewBox="0 0 19 19"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M18.9273 4.32273C18.9273 3.7067 18.6826 3.11591 18.247 2.68031C17.8114 2.24472 17.2206 2 16.6046 2H5.32273C4.70778 2.00348 4.11901 2.24932 3.68416 2.68416C3.24932 3.11901 3.00348 3.70778 3 4.32273V12.95C3.022 13.5879 3.24686 14.2021 3.64191 14.7033C4.03696 15.2046 4.5816 15.5668 5.19664 15.7373C13.2466 17.6154 12.7555 17.5291 13.1138 17.5291C13.5375 17.5425 13.9519 17.4036 14.2818 17.1376C14.5028 16.9502 14.6777 16.7145 14.7928 16.4486C14.9079 16.1827 14.9601 15.8939 14.9455 15.6046V9.17392C14.9456 8.55651 14.744 7.95597 14.3714 7.46363C13.9989 6.97129 13.4757 6.6141 12.8816 6.44637L5.69437 4.45546C5.56676 4.42114 5.45802 4.33753 5.39206 4.22303C5.32609 4.10853 5.30832 3.97252 5.34264 3.84491C5.37696 3.71731 5.46057 3.60856 5.57507 3.5426C5.68957 3.47664 5.82558 3.45886 5.95319 3.49318C8.42855 4.15682 8.28919 4.15682 8.32237 4.15682H16.6046C16.7366 4.15682 16.8632 4.20926 16.9565 4.3026C17.0499 4.39594 17.1023 4.52254 17.1023 4.65455C17.1023 4.78656 17.0499 4.91315 16.9565 5.0065C16.8632 5.09984 16.7366 5.15228 16.6046 5.15228H13.1271C13.0875 5.15358 13.0497 5.16902 13.0204 5.1958C12.9912 5.22258 12.9726 5.25893 12.9678 5.29828C12.9615 5.33851 12.9701 5.37969 12.9921 5.41396C13.0142 5.44823 13.048 5.47319 13.0873 5.4841C13.8688 5.68433 14.5661 6.12831 15.0782 6.75164C15.0943 6.77103 15.1147 6.78649 15.1377 6.79684C15.1607 6.80719 15.1857 6.81216 15.2109 6.81137H16.6046C16.7366 6.81137 16.8632 6.86381 16.9565 6.95715C17.0499 7.05049 17.1023 7.17709 17.1023 7.3091C17.1023 7.4411 17.0499 7.5677 16.9565 7.66105C16.8632 7.75439 16.7366 7.80683 16.6046 7.80683H15.9409C15.9145 7.80702 15.8885 7.81379 15.8653 7.82654C15.8422 7.83928 15.8225 7.8576 15.8082 7.87983C15.7971 7.90255 15.7913 7.92752 15.7913 7.95283C15.7913 7.97813 15.7971 8.0031 15.8082 8.02583C15.93 8.3964 15.9927 8.78384 15.994 9.17392V13.7796C15.994 13.8236 16.0115 13.8658 16.0426 13.8969C16.0737 13.928 16.1159 13.9455 16.1599 13.9455H16.6577C17.2644 13.9316 17.8417 13.6808 18.2659 13.2467C18.69 12.8126 18.9275 12.2297 18.9273 11.6227V4.32273ZM13.2864 11.9546C13.2864 12.2171 13.2085 12.4737 13.0627 12.692C12.9169 12.9102 12.7096 13.0803 12.467 13.1808C12.2245 13.2813 11.9576 13.3075 11.7002 13.2563C11.4427 13.2051 11.2062 13.0787 11.0206 12.8931C10.835 12.7075 10.7085 12.471 10.6573 12.2135C10.6061 11.956 10.6324 11.6892 10.7329 11.4466C10.8333 11.2041 11.0034 10.9968 11.2217 10.851C11.44 10.7051 11.6966 10.6273 11.9591 10.6273C12.3111 10.6273 12.6487 10.7671 12.8976 11.016C13.1465 11.2649 13.2864 11.6025 13.2864 11.9546Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}
export function RequestsIcon() {
	return (
		<IconWrap>
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M3.6001 7.19961C3.6001 6.24483 3.97938 5.32916 4.65451 4.65403C5.32964 3.97889 6.24532 3.59961 7.2001 3.59961H16.8001C17.7549 3.59961 18.6706 3.97889 19.3457 4.65403C20.0208 5.32916 20.4001 6.24483 20.4001 7.19961V16.7996C20.4001 17.7544 20.0208 18.6701 19.3457 19.3452C18.6706 20.0203 17.7549 20.3996 16.8001 20.3996H7.2001C6.24532 20.3996 5.32964 20.0203 4.65451 19.3452C3.97938 18.6701 3.6001 17.7544 3.6001 16.7996V7.19961ZM11.2249 8.52441C11.3376 8.41175 11.4009 8.25894 11.4009 8.09961C11.4009 7.94028 11.3376 7.78747 11.2249 7.67481C11.1122 7.56215 10.9594 7.49885 10.8001 7.49885C10.6408 7.49885 10.488 7.56215 10.3753 7.67481L8.6809 9.36921L8.2045 8.93481C8.08613 8.83364 7.93306 8.78244 7.77764 8.79205C7.62222 8.80166 7.47663 8.87131 7.37162 8.98629C7.26661 9.10127 7.21041 9.25257 7.21491 9.40822C7.2194 9.56387 7.28423 9.71168 7.3957 9.82041L8.2957 10.6424C8.40973 10.7462 8.55937 10.8022 8.71354 10.7986C8.86772 10.795 9.0146 10.7322 9.1237 10.6232L11.2249 8.52441ZM11.2249 13.6748C11.1692 13.6189 11.103 13.5746 11.0301 13.5444C10.9572 13.5141 10.879 13.4985 10.8001 13.4985C10.7212 13.4985 10.643 13.5141 10.5701 13.5444C10.4972 13.5746 10.431 13.6189 10.3753 13.6748L8.6809 15.3692L8.2045 14.9348C8.08613 14.8336 7.93306 14.7824 7.77764 14.792C7.62222 14.8017 7.47663 14.8713 7.37162 14.9863C7.26661 15.1013 7.21041 15.2526 7.21491 15.4082C7.2194 15.5639 7.28423 15.7117 7.3957 15.8204L8.2957 16.6424C8.40958 16.7464 8.55913 16.8025 8.7133 16.7992C8.86748 16.7958 9.01444 16.7332 9.1237 16.6244L11.2237 14.5244C11.3362 14.4119 11.3994 14.2593 11.3994 14.1002C11.3994 13.9411 11.3362 13.7885 11.2237 13.676M13.2001 14.3996C13.041 14.3996 12.8884 14.4628 12.7758 14.5753C12.6633 14.6879 12.6001 14.8405 12.6001 14.9996C12.6001 15.1587 12.6633 15.3114 12.7758 15.4239C12.8884 15.5364 13.041 15.5996 13.2001 15.5996H16.2001C16.3592 15.5996 16.5118 15.5364 16.6244 15.4239C16.7369 15.3114 16.8001 15.1587 16.8001 14.9996C16.8001 14.8405 16.7369 14.6879 16.6244 14.5753C16.5118 14.4628 16.3592 14.3996 16.2001 14.3996H13.2001ZM12.6001 8.99961C12.6001 9.15874 12.6633 9.31135 12.7758 9.42387C12.8884 9.5364 13.041 9.59961 13.2001 9.59961H16.2001C16.3592 9.59961 16.5118 9.5364 16.6244 9.42387C16.7369 9.31135 16.8001 9.15874 16.8001 8.99961C16.8001 8.84048 16.7369 8.68787 16.6244 8.57535C16.5118 8.46282 16.3592 8.39961 16.2001 8.39961H13.2001C13.041 8.39961 12.8884 8.46282 12.7758 8.57535C12.6633 8.68787 12.6001 8.84048 12.6001 8.99961Z"
					fill="white"
				/>
			</svg>
		</IconWrap>
	);
}

export function WarningTriangle(props) {
	return (
		<svg
			width="43"
			height="37"
			viewBox="0 0 43 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22.7839 0.999912L41.8359 33.9999C42.0115 34.3039 42.1039 34.6488 42.1039 34.9999C42.1039 35.351 42.0115 35.6959 41.836 35.9999C41.6604 36.3039 41.408 36.5564 41.1039 36.7319C40.7999 36.9075 40.455 36.9999 40.1039 36.9999H1.99995C1.64888 36.9999 1.304 36.9075 0.999967 36.7319C0.695936 36.5564 0.443467 36.3039 0.267936 35.9999C0.0924058 35.6959 -2.22966e-06 35.351 0 34.9999C2.22974e-06 34.6488 0.0924148 34.3039 0.267949 33.9999L19.3199 0.999912C19.4955 0.695897 19.748 0.443444 20.052 0.267923C20.356 0.092403 20.7009 0 21.0519 0C21.403 0 21.7479 0.092403 22.0519 0.267923C22.3559 0.443444 22.6084 0.695897 22.7839 0.999912ZM19.0519 26.9999V30.9999H23.0519V26.9999H19.0519ZM19.0519 12.9999V22.9999H23.0519V12.9999H19.0519Z"
				fill="#EC221F"
			/>
		</svg>
	);
}
